import { render, staticRenderFns } from "./swiper_list.vue?vue&type=template&id=3479fc27&scoped=true&"
import script from "./swiper_list.vue?vue&type=script&lang=js&"
export * from "./swiper_list.vue?vue&type=script&lang=js&"
import style0 from "./swiper_list.vue?vue&type=style&index=0&id=3479fc27&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3479fc27",
  null
  
)

export default component.exports